import angular from 'angular';

import tszNotificationBadge from './tsz-notification-badge';

const tszNotificationBadgeModule = angular.module('tsz.components.tszNotificationBadge', [])
  .component('tszNotificationBadge', tszNotificationBadge);

export default tszNotificationBadgeModule;



// WEBPACK FOOTER //
// ./src/components/tsz-notification-badge/tsz-notification-badge.module.js